// import: styles
import { Box, Dialog } from '@mui/material';

// import: assets
// import: config
// import: constants
import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { proratedPricePopUpStyles } from 'core/layouts/components/subscription-plans/components/prorated-price-pop-up/ProratedPricePopUpStyles';

// import: components
import SubscriptionCard from 'core/layouts/components/subscription-plans/components/subscription-card/SubscriptionCard';
import { ACCOUNT, PAYMENT_SUCCESSFUL } from 'core/navigation/Routes';

// import: services
// import: redux
import {
	getProratedPriceApiStageSelector,
	getSubscriptionPayLinkAsync,
	openProratedPricePopUpSelector,
	proratedPriceSelector,
	toggleProratedPricePopUp,
} from 'core/store/reducers/profileReducer/ProfileSlice';

// import: utils
import { formatPrice } from 'core/utils/utils';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// import: lazy load components

function ProratedPricePopUp() {
	const dispatch = useDispatch();

	const getProratedPriceApiStage = useSelector(getProratedPriceApiStageSelector);
	const proratedPlan = useSelector(proratedPriceSelector);
	const open = useSelector(openProratedPricePopUpSelector);
	const location = useLocation();
	const cancelUrl = `${window.location.origin}${location.pathname}?${location.search}`;
	const successUrl = `${window.location.origin}/${ACCOUNT}/${PAYMENT_SUCCESSFUL}`;

	const onClose = () => {
		dispatch(toggleProratedPricePopUp(false));
	};

	const handleSubscriptionPlanButtonClick = () => {
		dispatch(
			getSubscriptionPayLinkAsync({
				price: proratedPlan.price,
				subscriptionType: proratedPlan.planType,
				successUrl: `${successUrl}${!Number.isNaN(proratedPlan.price / 100) ? `?value=${proratedPlan.price / 100}` : ''}`,
				cancelUrl,
			}),
		);
	};

	return (
		<Dialog
			id="prorated-price-dialog"
			open={open}
			aria-labelledby="prorated-price"
			onClose={onClose}
			sx={proratedPricePopUpStyles.dialog}
		>
			<Box sx={[proratedPricePopUpStyles.popUp]}>
				{getProratedPriceApiStage === ApiStage.LOADING && (
					<SubscriptionCard id="sk-loader" loading />
				)}
				{getProratedPriceApiStage === ApiStage.SUCCESS && (
					<SubscriptionCard
						id={proratedPlan.name}
						plan={proratedPlan}
						planType={proratedPlan.planType}
						loading={false}
						buttonText={`Upgrade for $${formatPrice(proratedPlan.newPrice)}`}
						onButtonClick={handleSubscriptionPlanButtonClick}
						disableButton={false}
					/>
				)}
			</Box>
		</Dialog>
	);
}

export default ProratedPricePopUp;
